import React from 'react';

export const Logo = ({ className = '' }) => {
  return (
    <svg
      width="220"
      height="50"
      viewBox="0 0 220 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Icon - Stylized building/energy symbol with blue and red */}
      <rect x="2" y="10" width="12" height="30" fill="#2563eb" rx="1" />
      <rect x="16" y="15" width="12" height="25" fill="#dc2626" rx="1" />
      <rect x="30" y="8" width="12" height="32" fill="#1e40af" rx="1" />
      
      {/* Energy waves - red accent */}
      <path d="M 8 18 Q 11 20 14 18" stroke="#ef4444" strokeWidth="2" fill="none" />
      <path d="M 22 23 Q 25 25 28 23" stroke="#3b82f6" strokeWidth="2" fill="none" />
      <path d="M 36 16 Q 39 18 42 16" stroke="#dc2626" strokeWidth="2" fill="none" />
      
      {/* Text */}
      <text x="55" y="28" fontFamily="system-ui, -apple-system, sans-serif" fontSize="22" fontWeight="700" fill="#1e293b">
        SB Consulting
      </text>
      <text x="56" y="42" fontFamily="system-ui, -apple-system, sans-serif" fontSize="9" fontWeight="400" fill="#64748b" letterSpacing="0.5">
        ÉTUDES THERMIQUES
      </text>
    </svg>
  );
};
